import INDEX from './seoPageIndex.json';

// Address and link label of each page in seoPages.json (pages/public/
// SeoPage.jsx), per language: English at /<slug>, the others at
// /<lang>/<slug>. scripts/build-locale-pages.js writes the same ones.
export const SEO_LANGS = ['en', 'fr', 'es', 'pt', 'nl', 'de'];

export const SEO_PAGES = Object.keys(INDEX);

export const seoPagePath = (page, lang) =>
  (lang === 'en' ? `/${INDEX[page].en.slug}` : `/${lang}/${INDEX[page][lang].slug}`);

export const seoPageLabel = (page, lang) => (INDEX[page][lang] || INDEX[page].en).label;

export const SEO_PAGE_ROUTES = SEO_PAGES.flatMap((page) =>
  SEO_LANGS.map((lang) => ({ page, lang, path: seoPagePath(page, lang) })));
